import type { PaginationPanelProps } from './pagination-panel.interface';

import classNames from 'classnames';
import { memo, useEffect, useState } from 'react';

export const PaginationPanel = memo(
  ({ totalPages, page, changePage }: PaginationPanelProps) => {
    const [buttonsArray, setButtonsArray] = useState<number[]>([]);

    useEffect(() => {
      const newButtonsArray = Array.from(
        { length: totalPages },
        (_, index) => index,
      );
      setButtonsArray(newButtonsArray);
    }, [totalPages]);

    return (
      <div className="pagination-list">
        {buttonsArray.map((p) => (
          <div
            key={p}
            onClick={() => changePage(p)}
            className={classNames('pagination-button', { active: p === page })}
          >
            <div className="pagination-button__number">{p + 1}</div>
          </div>
        ))}
      </div>
    );
  },
);

PaginationPanel.displayName = 'PaginationPanel';
